<template>
  <section class="fullscreen-section hero-section" ref="section">
    <!-- 배경 이미지 -->
    <div class="section-bg">
      <img :src="bgImage" class="bg-image" alt="hero background" />
      <div class="bg-overlay"></div>
    </div>

    <!-- 텍스트 콘텐츠 -->
    <div class="hero-content">
      <p class="sub-title" :class="{ visible: animations.subTitle }">Another World Unfolds</p>
      <h1 class="main-title" :class="{ visible: animations.title1 }">구미 그 위에 펼쳐지는</h1>
      <h1 class="main-title" :class="{ visible: animations.title2 }">또 다른 세상</h1>
      <div class="divider" :class="{ visible: animations.divider }"></div>
      <p class="desc-line" :class="{ visible: animations.desc1 }">일상을 벗어나 새로운 풍경 속으로</p>
      <p class="desc-line" :class="{ visible: animations.desc2 }">당신만의 특별한 순간이 시작됩니다</p>
      <div class="scroll-indicator" :class="{ visible: animations.scroll }">
        <span class="scroll-text">Scroll</span>
        <div class="scroll-line"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      bgImage: require('@/assets/banner1.jpg'),
      animations: {
        subTitle: false,
        title1: false,
        title2: false,
        divider: false,
        desc1: false,
        desc2: false,
        scroll: false
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.startAnimations()
    })
  },
  methods: {
    getSection() {
      return this.$refs.section
    },
    startAnimations() {
      const delays = [
        { key: 'subTitle', delay: 300 },
        { key: 'title1', delay: 600 },
        { key: 'title2', delay: 900 },
        { key: 'divider', delay: 1200 },
        { key: 'desc1', delay: 1500 },
        { key: 'desc2', delay: 1700 },
        { key: 'scroll', delay: 2200 }
      ]

      delays.forEach(({ key, delay }) => {
        setTimeout(() => {
          this.animations[key] = true
        }, delay)
      })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Noto+Serif+KR:wght@300;400;500&display=swap');

.fullscreen-section {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 25vh;
  overflow: hidden;
}

.hero-section {
  margin-top: -80px;
  padding-top: 80px;
}

/* 배경 영상 */
.section-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  animation: slowZoom 20s ease-out forwards;
}

@keyframes slowZoom {
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
  z-index: 2;
}

/* 텍스트 콘텐츠 */
.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
}

.main-title {
  font-family: 'Noto Serif KR', serif;
  font-size: 52px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 8px;
  margin: 0 0 10px 0;
  text-shadow: 0 2px 30px rgba(0, 0, 0, 0.6), 0 4px 60px rgba(0, 0, 0, 0.4);
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.main-title.visible {
  opacity: 1;
  transform: translateY(0);
}

.sub-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 24px;
  font-weight: 400;
  font-style: italic;
  color: #ffffff;
  margin: 0 0 20px 0;
  letter-spacing: 4px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.sub-title.visible {
  opacity: 1;
  transform: translateY(0);
}

.divider {
  width: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.5);
  margin: 40px auto;
  transition: width 0.8s ease;
}

.divider.visible {
  width: 60px;
}

.desc-line {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 2px;
  margin: 8px 0;
  text-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.desc-line.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 스크롤 인디케이터 */
.scroll-indicator {
  position: absolute;
  bottom: -120px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  transition: opacity 1s ease;
}

.scroll-indicator.visible {
  opacity: 1;
}

.scroll-text {
  font-family: 'Cormorant Garamond', serif;
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 3px;
  margin-bottom: 10px;
}

.scroll-line {
  width: 1px;
  height: 50px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), transparent);
  animation: scrollPulse 2s ease-in-out infinite;
}

@keyframes scrollPulse {
  0%, 100% {
    transform: scaleY(1);
    opacity: 0.7;
  }
  50% {
    transform: scaleY(1.3);
    opacity: 1;
  }
}

/* 반응형 */
@media (max-width: 1024px) {
  .hero-section {
    margin-top: -65px;
    padding-top: 65px;
  }
  .main-title {
    font-size: 44px;
    letter-spacing: 6px;
  }
  .sub-title {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 36px;
    letter-spacing: 4px;
  }
  .sub-title {
    font-size: 18px;
  }
  .desc-line {
    font-size: 14px;
    letter-spacing: 1px;
  }
  .divider {
    margin: 30px auto;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 28px;
    letter-spacing: 3px;
  }
  .sub-title {
    font-size: 16px;
    letter-spacing: 2px;
  }
  .desc-line {
    font-size: 13px;
    padding: 0 20px;
  }
}
</style>
